export const Constants = {
  TAG_NAME: 'pop-contributors-detractors-chart-component',
  CHART_NO_DATA_MESSAGE: 'Chart unavailable',
  CONTRIBUTORS_X_AXIS_LABEL: 'Contributors',
  DETRACTORS_X_AXIS_LABEL: 'Detractors',
  Y_AXIS_LABEL: '% of portfolio',
  TOP_TEN_CONTRIBUTORS_LABEL: 'Top 10 Contributors',
  TOP_TEN_DETRACTORS_LABEL: 'Top 10 Detractors',
  CONTRIBUTOR_TOOLTIP_TEXT: 'Contributor',
  DETRACTOR_TOOLTIP_TEXT: 'Detractor',
  NO_DATA_VALUE: 'N/A',
} as const;
